import { useEffect, useState } from "react";
import Lightbox from "react-image-lightbox";
import styled from "styled-components";
import { useAppContext } from "../../context";
import { formatDatetime, formatEmail } from "../../utils";
import dayjs from "dayjs";
import useAppData from "../../customHooks/useAppData";

export interface RenderLightBoxImage {
    url: string;
    title: string;
    comments: string;
    createdBy: string;
    createdAt: string | Date;
}

export default function CustomLightBox ({
    images,
    lightBoxOpen,
    setLightBoxOpen,
    index,
    deleteImage
}: {
    images: Array<RenderLightBoxImage>;
    lightBoxOpen: boolean;
    setLightBoxOpen: React.Dispatch<React.SetStateAction<boolean>>;
    index?: number;
    deleteImage?: (url: string) => Promise<void>;
}) {

    const { setLoading } = useAppContext();
    const [photoIndex, setPhotoIndex] = useState(0);

    useEffect(() => {
        if (index) setPhotoIndex(index);
    }, [index]);

    const handleDeleteImage = async (url: string) => {
        setLoading(true);
        await deleteImage(url);
        setLightBoxOpen(false);
        setLoading(false);
    }

    if (!lightBoxOpen || !images) {
        return null;
    }

    return (
        // @ts-ignore
        <Lightbox
            mainSrc={images[photoIndex].url}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={
                images[(photoIndex + images.length - 1) % images.length]
            }
            onCloseRequest={() => setLightBoxOpen(false)}
            onMovePrevRequest={() =>
                setPhotoIndex(
                    (photoIndex + images.length - 1) % images.length
                )
            }
            onMoveNextRequest={() =>
                setPhotoIndex((photoIndex + 1) % images.length)
            }
            imageTitle={<h1>{images[photoIndex].title}</h1>}
            imageCaption={(
                <ImageCaption
                    title={images[photoIndex].title}
                    comments={images[photoIndex].comments}
                    createdBy={images[photoIndex].createdBy}
                    createdAt={formatDatetime(images[photoIndex].createdAt)}
                    url={images[photoIndex].url}
                    handleDeleteImage={deleteImage ? handleDeleteImage : undefined}
                />
            )}
        />
    );
}

const ImageCaption = ({
    title,
    comments,
    createdBy,
    createdAt,
    url,
    handleDeleteImage
}: {
    title: string;
    comments: string;
    createdBy: string;
    createdAt: string | Date;
    url: string;
    handleDeleteImage?: (url: string) => Promise<void>;
}) => {
    return (
        <div className="row" style={{ width: '100%' }}>
            <div className="col-12" style={{ width: '100%' }}>
                <h1>
                    {title}: {comments}.{' '}
                    Created by {formatEmail(createdBy)} at{' '}
                    {dayjs(createdAt).format(
                        'MM/DD/YYYY HH:mm'
                    )}
                </h1>
            </div>
            <ImageCaptionIconsContainer>
                {/* <div className="bg-warning text-center">
                    <i
                        style={{ fontSize: '48px' }}
                        className="far fa-envelope visual-caption-icon"
                        onClick={() => generateReport('email')}
                    ></i>
                </div>
                <div className="bg-secondary text-center">
                    <i
                        style={{ fontSize: '48px' }}
                        className="fas fa-cloud-download-alt visual-caption-icon"
                        onClick={() => generateReport('print')}
                    ></i>
                </div> */}
                {
                    Boolean(handleDeleteImage) !== false && (
                        <div className="bg-danger text-center">
                            <i
                                style={{ fontSize: '40px' }}
                                className="fas fa-trash visual-caption-icon"
                                onClick={() => handleDeleteImage(url)}
                            ></i>
                        </div>
                    )
                }
            </ImageCaptionIconsContainer>
        </div>
    );
}

const ImageCaptionIconsContainer = styled.div`
    display: flex;
    width: 100%;

    & div {
        flex: 1;
    }
`;
